module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticClass: "marmoset-viewer",
    attrs: {
      "src": "about:blank"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bff726c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/MarmosetViewer.vue
// module id = 2124
// module chunks = 2